module.exports = __webpack_public_path__ + "static/img/zhezhao.b48886d8.png";